import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';

// assets
import CssAppStoreLogos from './AppStoreLogos.scss';

function AppStoreLogos(props) {
  const { height } = props;

  useStyles(CssAppStoreLogos);
  return (
    <div className="app-store-logos">
      <div className="app-store-logos__button">
        <a
          href="https://apps.apple.com/app/ckbk/id1476621703"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            loading="lazy"
            src="images/appstore.png"
            height={height}
            alt="Download on the App Store"
          />
        </a>
      </div>
      <div className="app-store-logos__button">
        <a
          href="https://play.google.com/store/apps/details?id=com.ckbk.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            loading="lazy"
            src="images/playstore.png"
            height={height}
            alt="Pre-register on Google Play"
          />
        </a>
      </div>
    </div>
  );
}

AppStoreLogos.propTypes = {
  height: PropTypes.number,
};

AppStoreLogos.defaultProps = {
  height: 50,
};

export default AppStoreLogos;
